import React, { useState } from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
import UserTagDropDown from "./UserTagDropDown";
import { ReactComponent as NotificationBill } from "../../../../public/shared/notification-bill.svg";
import { ReactComponent as NotificationBillI } from "../../../../public/shared/notification-bill-i.svg";
import { ReactComponent as SettingsIcon } from "../../../../public/shared/settings.svg";
import { useSelector } from "react-redux";
import { FaInfoCircle } from "react-icons/fa";
import RollOver from "../../../RollOver";

export default () => {
  const user = useSelector(({ current_user }) => current_user);
  const [showTooltip, setShowTooltip] = useState(false);
  if (!user) {
    return <></>;
  }
  return (
    <div>
      <div id="user_controls" className="d-flex justify-content-between align-items-center m-4">
        <UserTagDropDown user={user} />
        <div className="d-flex align-items-center">
          <Link id="notifications" to="/notifications">
            {user && user.unread_notifications_count ? <NotificationBillI className="ml-2" /> : <NotificationBill className="ml-2" />}
          </Link>
          <Link to="/settings">
            <SettingsIcon className="ml-2" />
          </Link>
        </div>
      </div>
      <div className="d-flex flex-row align-items-center ml-4" style={{ marginTop: -20, marginBottom: -7, position: "relative" }}>
        <strong style={{ color: "#888" }}>My Account Balance: </strong>
        <div style={{ color: "#0c0", marginLeft: 7 }}>
          {Number(user?.bank_total || 0).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          (USD)
        </div>

        <FaInfoCircle
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          style={{ fontSize: 16, marginLeft: 8, color: "#0c0" }}
        />
        {showTooltip && (
          <div
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{
              position: "absolute",
              backgroundColor: "#0008",
              color: "white",
              padding: 10,
              borderRadius: 10,
              width: 200,
              top: 10,
              right: 40,
              backdropFilter: "blur(1rem)",
            }}
          >
            Want some cold hard cash?{" "}
            <Link style={{ textDecoration: "underline", color: "#fff" }} to="/refer">
              Refer your friends and get $5 for each one that registers!
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};
